export const tableConfig = [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return rowNumber;
      },
    },
  },
  {
    name: "driverId",
    label: "ID Sopir",
    options: {
      sort: false,
    },
  },
  {
    name: "driverUsername",
    label: "Username",
    options: {
      sort: false,
    },
  },
  {
    name: "driverName",
    label: "Nama Sopir",
    options: {
      sort: false,
    },
  },
  {
    name: "driverCabang",
    label: "Cabang Bertugas",
    options: {
      sort: false,
      customBodyRender: (val) =>
        val?.map((item) => item?.namaCabang).join(", "),
    },
  },
];

export const formGroup = {
  driverId: { value: null, mandatory: true },
  driverUsername: { value: null, mandatory: true },
  driverName: { value: null, mandatory: true },
  driverCabang: { value: null, mandatory: true },
};

export const initialPagination = {
  limit: 5,
  page: 1,
  totalData: 5,
};

export const initialFilter = {
  driverUsername: null,
  driverName: null,
  driverCabang: null,
  driverStatus: null,
};
